import { message } from "antd";
import { useCallback, useState } from "react";
import { getOverTimeProjectComments } from "../../../../config";

const useOverTimeTable = () => {
    const [projectInformation, setProjectInformation] = useState({
        projects: [],
        quantities: {
            technical_knowledge: {
                title: "technical_knowledge",
                times: 0,
                totalScore: 0,
            },
            quality: {
                title: "quality",
                times: 0,
                totalScore: 0,
            },
            missing_documentation: {
                title: "missing_documentation",
                times: 0,
                totalScore: 0,
            },
            technical_difficulty: {
                title: "technical_difficulty",
                times: 0,
                totalScore: 0,
            },
            quotation: {
                title: "quotation",
                times: 0,
                totalScore: 0,
            },
            provider: {
                title: "provider",
                times: 0,
                totalScore: 0,
            },
            negotiation: {
                title: "negotiation",
                times: 0,
                totalScore: 0,
            },
            management_monitoring: {
                title: "management_monitoring",
                times: 0,
                totalScore: 0,
            },
            pause: {
                title: "pause",
                times: 0,
                totalScore: 0,
            },
        },
    });
    const [isLoading, setIsLoading] = useState(false);

    const updateProjects = useCallback(async (year) => {
        setIsLoading(true);
        try {
            const data = await getOverTimeProjectComments(year);
            const { payload } = data;
            const { projects, quantities } = payload;
            setProjectInformation({ projects, quantities });
        } catch (error) {
            console.log(error);
            message.error("Error recuperando proyectos");
        } finally {
            setIsLoading(false);
        }
    }, []);

    return { projects: projectInformation.projects, quantities: projectInformation.quantities, isLoading, updateProjects };
};

export default useOverTimeTable;
